export const cookieName = 'amp_SID';
export const amplitudeKey = '7144cb1c738a6979511fde50990dd158';
